import { createContext } from 'react';

import { AuthData } from './types';

// undefined means no AuthProvider above the consumer; a present provider always
// supplies an AuthSession (an unauthenticated one when logged out).
export const AuthDataContext = createContext<AuthData | undefined>(undefined);
